import React from 'react';
import { ExternalLink, Loader2 } from 'lucide-react';

function Preview({ port }) {
  if (!port) {
    return (
      <div className="h-full flex items-center justify-center bg-white text-gray-600">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto mb-2" />
          <p className="text-sm">Setting up preview...</p>
        </div>
      </div>
    );
  }

  const previewUrl = `http://localhost:${port}`;

  return (
    <div className="h-full flex flex-col">
      <div className="h-10 bg-gray-800 border-b border-gray-700 flex items-center px-3 justify-between">
        <span className="text-sm text-gray-300">Preview</span>
        <a
          href={previewUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 transition-colors"
        >
          <ExternalLink size={16} />
        </a>
      </div>
      <iframe
        src={previewUrl}
        className="flex-1 w-full bg-white"
        title="Preview"
      />
    </div>
  );
}

export default Preview;
